import { jsx as n } from "react/jsx-runtime";
import { Slot as m } from "@radix-ui/react-slot";
import { forwardRef as f } from "react";
import { c as v } from "./cn-DlLpp5ix.js";
const x = {
  none: "0",
  sm: "var(--space-3)",
  // 12
  md: "var(--space-4)",
  // 16
  lg: "var(--space-5)",
  // 20
  xl: "var(--space-6)"
  // 24
}, b = {
  lg: "var(--radius-lg)",
  xl: "var(--radius-xl)",
  "2xl": "var(--radius-2xl)",
  "3xl": "var(--radius-3xl)"
}, g = f(function({
  children: a,
  padding: r = "md",
  radius: o = "2xl",
  interactive: t = !1,
  selected: d = !1,
  asChild: u = !1,
  className: s,
  style: p,
  ...e
}, l) {
  const i = {
    display: "block",
    padding: x[r],
    background: d ? "var(--bg-elevated)" : "var(--bg-surface)",
    border: "1px solid var(--border-default)",
    borderRadius: b[o],
    color: "var(--text-primary)",
    transition: "background var(--duration-fast) var(--ease-out), border-color var(--duration-fast) var(--ease-out)",
    cursor: t ? "pointer" : void 0,
    ...p
  }, c = {
    "data-ls-component": "card",
    "data-padding": r,
    "data-radius": o,
    "data-interactive": t ? "true" : void 0,
    "data-selected": d ? "true" : void 0
  };
  return u ? /* @__PURE__ */ n(
    m,
    {
      ref: l,
      ...c,
      className: v(s),
      style: i,
      ...e,
      children: a
    }
  ) : /* @__PURE__ */ n(
    "div",
    {
      ref: l,
      ...c,
      className: v(s),
      style: i,
      ...e,
      children: a
    }
  );
});
g.displayName = "Card";
export {
  g as C
};
//# sourceMappingURL=Card-BpiP0p3P.js.map
